import httpClient from '@/apis/base/httpclient';
import DashboardApi from './_dashboardApi';

class DashboardCashBalanceDepositAPI extends DashboardApi {
  constructor() {
    super();
  }
  controllerName = 'Dashboards';

  /**
   * Hàm lấy dữ liệu cho biểu đồ
   * @returns
   * PTTAM 21.06.2023
   */
  async getChartData(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataChart',
      data: param,
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Hàm lấy dữ liệu cho biểu đồ ava
   * @returns
   * NBTIN 28.05.2024
   */
  async getChartDataMisaAva(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataChartMisaAva',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin biểu đồ theo id
   * @param {} param
   * @returns
   */
  async getChartDataById(param) {
    let request = {
      url: this.getAPIUrl() + '/DataChartById',
      data: param,
    };
    return await httpClient.getAsync(request);
  }
}

export default new DashboardCashBalanceDepositAPI();
